import { render, staticRenderFns } from "./StaticsHeader.vue?vue&type=template&id=4fee1244&scoped=true"
import script from "./StaticsHeader.vue?vue&type=script&lang=js"
export * from "./StaticsHeader.vue?vue&type=script&lang=js"
import style0 from "./StaticsHeader.scss?vue&type=style&index=0&id=4fee1244&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fee1244",
  null
  
)

export default component.exports